import { render, staticRenderFns } from "./quotation_info_edit.vue?vue&type=template&id=3ed3a4da&scoped=true"
import script from "./quotation_info_edit.vue?vue&type=script&lang=js"
export * from "./quotation_info_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed3a4da",
  null
  
)

export default component.exports